// Generated by CoffeeScript 2.7.0
var PhaseFieldsLogicModal;

import Modal from 'trunks/vue/admin/components/modals/modal.js';

import LogicForm from 'trunks/vue/admin/compositions/logic_form.js';

export default PhaseFieldsLogicModal = Vue.extend({
  components: {
    modal: Modal,
    'logic-form': LogicForm
  },
  props: {
    vertex: {
      type: Object,
      default: function() {
        return {};
      }
    }
  },
  data: function() {
    var ref;
    return {
      logicSettings: ((ref = this.vertex.logic_settings) != null ? ref.constraints : void 0) || {}
    };
  },
  watch: {
    vertex: function(value) {
      var ref;
      return this.logicSettings = ((ref = value.logic_settings) != null ? ref.constraints : void 0) || {};
    }
  },
  template: `<modal title='设置回传逻辑'
       extendClass='phase-fields-modal phase-fields-logic-modal'
       :backdrop='true'
       @ensureClicked="ensureClickedFunc"
       ref='modal'>
  <template>
    <logic-form
      v-if="vertex.fields.length > 0"
      :formable="vertex"
      @logicSettingChanged="logicSettingChangedFunc"
    />
    <div v-else class="blankslate">
      <div class="circle-index blankslate-icon">
        <i class="slp-list-square-o"></i>
      </div>
      <p>没有任何字段</p>
    </div>
  </template>
</modal>`,
  methods: {
    logicSettingChangedFunc: function(logic_settings) {
      return this.logicSettings = logic_settings;
    },
    ensureClickedFunc: function() {
      return this.$emit('ensureClicked', this.logicSettings);
    },
    updateSettings: function(settings) {
      return _.extend(this, settings);
    },
    open: function() {
      return this.$refs.modal.open();
    }
  }
});
